import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./styles.css";
import { EffectCoverflow, Autoplay } from "swiper/modules";
import { TestimonialCard } from "./TestimonialCard";

export const Testimonials = () => {
  const [swiper, setSwiper] = useState(null);

  const projects = [
    {
      caption: "Pine Labs",
      statement: `"Infra Monitoring solutions/offerings are available from other vendors. But if I talk about the complete comprehensive Infra monitoring with enterprise-grade observability suite, the capability SolarWinds has, I don’t think some other vendors will have those capabilities"`,
      author: ` -Somil Goyal (Infra Architect)`,
    },
    {
      caption: "Axis Bank Limited",
      statement: `"We confirm that Techsa Services Pvt Limited has successfully deployed the SolarWinds Network Monitoring Software solution at Axis Bank. The solution is effectively monitoring over 20,000 devices across the bank's data center (DC), local area network (LAN), and wide area network (WAN) environments. We are happy to report that the solution is operating satisfactorily and meeting our expectations.    
      
      Thank you for your continued support and collaboration."
      `,
      author: `- Rajani Kumar N.E.V`,
    },
    {
      caption: "DCB Bank Limited",
      statement: `"Techsa Services has installed HCL BigFix licenses on over 10,000 assets (Laptops, PCs, and Servers) in DCB Bank. The Patch Management & Compliance Remediation functionality of the installed software and the associated support services from Techsa Services Pvt Ltd are found to be satisfactory and meet our requirements."
      `,
      author: `- Sanjay Shintre (Head Infrstructure Projects and Operations)`,
    },
    {
      caption: "Concentrix Daksh Services India Private Limited",
      statement: `"Techsa Services Private Limited has installed HCL BigFix licenses on over
350,000 assets (Laptops, PCs, and Servers) in Concentrix Daksh Services India Private Limited.
The Patch Management & Compliance Remediation functionality of the installed software and the
associated support services from Techsa Services Pvt Ltd are found to be satisfactory and meet our
requirements."
      `,
      author: `- Pankaj Potdar (Senior Director, Global Server)`,
    },
    {
      caption: "Saraswat Bank Limited",
      statement: `"Techsa services Pvt ltd has installed the HCL Bigfix licenses on over 8000 assets (Laptops, PCs, and Servers) in Saraswat Bank Limited. The Patch Management & Compliance Remediation functionality of the installed software and the associated support services from Techsa Services Pvt Ltd are found to be satisfactory and meet our requirements."
      `,
      author: ` - Milind Sawant (Deputy General Manager)`,
    },
  ];

  const handleMouseEnter = () => {
    if (swiper) {
      swiper.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiper) {
      swiper.autoplay.start();
    }
  };

  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        loop={true}
        navigation={true}
        modules={[EffectCoverflow, Autoplay]}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        className="mySwiper"
        onSwiper={(swiper) => setSwiper(swiper)}
      >
        {projects.map((contents, index) => (
          <SwiperSlide key={index}>
            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <TestimonialCard
                key={contents.id}
                name={contents.caption}
                statement={contents.statement}
                author={contents.author}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};
